import { mountStagingBanner } from '@dmre/env-banner/banner';
import { CssBaseline } from '@mui/material';
import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import awsConfig from './aws-config';

mountStagingBanner();

// ✅ Configure Amplify
Amplify.configure(awsConfig);
//console.log("Amplify Configured:", awsConfig);  // Debugging log

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>,
);
